import { MessageCode, SocketState, WorkerEvent, SocketMessage } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'

export interface WorkerData<T = MessageCode | SocketState | string> {
	type: WorkerEvent
	payload: T
}

export interface ChannelHandler {
	work: Callback<SocketMessage, void>
}

export enum AppSocketType {
	NEO = 'NEO',
	'UNI_CHAT' = 'UNI_CHAT',
}

export type WorkerMessageData<T = unknown> = {
	appSocketType: AppSocketType
	data: WorkerData<T>
}

export type SendMessageType = (data: WorkerMessageData) => void
